/** Custom attribute refs not shown in Personal Information. */
export const HIDDEN_CUSTOM_ATTRIBUTE_REFS: string[] = [
  'validVisa',
  'onboardingPercentage',
  'onboardingCompleted',
];

export const AHPRA_REGISTRATION_NUMBER_REF = 'ahpraRegistrationNumberNoChild';
export const AHPRA_REGISTRATION_NUMBER_LABEL = 'AHPRA Registration Number';

const EXPLICIT_CUSTOM_ATTRIBUTE_LABEL_BY_REF: Record<string, string> = {
  [AHPRA_REGISTRATION_NUMBER_REF]: AHPRA_REGISTRATION_NUMBER_LABEL,
};

/** Rendered explicitly in Personal Information (excluded from the dynamic list). */
export const EXPLICIT_CUSTOM_ATTRIBUTE_REFS: string[] = Object.keys(
  EXPLICIT_CUSTOM_ATTRIBUTE_LABEL_BY_REF,
);

export const getExplicitCustomAttributeLabel = (ref: string): string =>
  EXPLICIT_CUSTOM_ATTRIBUTE_LABEL_BY_REF[ref] ?? ref;
